import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { form } from 'helpers/decorators'
import validate from './acceptActivity.validate'
import { apiAssessors } from 'helpers/decorators/api'
import { injectIntl } from 'react-intl'
import AcceptActivityForm from '../../../../components/forms/AcceptActivityForm/AcceptActivityForm'


@apiAssessors()
@form({
  form: 'acceptParticipant',
  disableHook: true,
  validate
})
@injectIntl
class AcceptActivity extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    onAcceptActivity: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    submitting: PropTypes.bool,
    isActivityRequest: PropTypes.bool,
    isRpRequest: PropTypes.bool,
    isAjRequest: PropTypes.bool,
    intl: PropTypes.object
  }

  state = {
    isAccept: false
  }

  handleAcceptActivity = (fields, isAccepted) => {
    const { id, onAcceptActivity, isRpRequest, isActivityRequest, isAjRequest } = this.props

    const activityId = isActivityRequest ? id : null

    const residentialProjectId = isRpRequest ? id : null

    const ajId = isAjRequest ? id : null

    return onAcceptActivity(fields, isAccepted, activityId, residentialProjectId, ajId)
  }

  handleRejectActivity = fields => this.handleAcceptActivity(fields, false)

  handleWantReject = () =>
    this.setState({
      isAccept: true
    })

  handleOnClose = () => {
    this.props.reset()
    this.setState({
      isAccept: false
    })
  }

  render() {
    const {
      modalId,
      colorClass,
      handleSubmit,
      submitting
    } = this.props
    const { isAccept } = this.state

    return (
      <MaterialModal.Body
        id={modalId}
        title="Accept Activity"
        titleKey="moduleTitle.accept_activity"
        colorClass={colorClass}
        onClose={this.handleOnClose}
      >
        <form
          onSubmit={handleSubmit(
            fields =>
              isAccept
                ? this.handleRejectActivity(fields)
                : this.handleAcceptActivity(fields, true)
          )}
        >
          <MaterialModal.Content>
            <AcceptActivityForm
              onReject={this.handleWantReject}
              isAccept={isAccept}
              {...this.props}
            />
          </MaterialModal.Content>

          <MaterialModal.Footer
            action="Send"
            actionKey={isAccept ? 'button.reject' : 'button.send'}
            colorClass={colorClass}
            isLoading={submitting}
          />
        </form>
      </MaterialModal.Body>
    )
  }
}

export default AcceptActivity
